import { Modal, Button } from '@superops/ui-design-system';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import React, { useCallback, useState } from 'react';
import { getTranslatedText } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const ModalPopOverButton = (props) => {
  const sanitizer = dompurifier;
  const { cell, intl } = props;
  const { row } = cell;
  const modalData = row.original.statusMessage;
  const [modalActive, setModalActive] = useState(false);
  const toggleModal = useCallback(() => setModalActive(!modalActive), [
    modalActive
  ]);

  return (
    <div className="">
      <Button
        id={'rmmShowScriptOutput'}
        secondary
        onClick={toggleModal}
        icon={
          <div className="flex actr mr-5">
            <SVGIcon name="RemoteDesktop" />
          </div>
        }
      >
        <div
          className="wm-200 overflow-ellipses"
          title={getTranslatedText(
            intl,
            'asset.executedScript.scriptOutput.btn'
          )}
        >
          <FormattedMessage id="asset.executedScript.scriptOutput.btn" />
        </div>
      </Button>
      <Modal
        open={modalActive}
        onClose={toggleModal}
        title={getTranslatedText(intl, 'asset.executedScript.output.header')}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: toggleModal
          }
        ]}
      >
        <div>
          <div className="break-spaces p20">
            {modalData ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizer(modalData)
                }}
              />
            ) : (
              <FormattedMessage id="asset.script.no.output.to.display" />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default injectIntl(ModalPopOverButton);
